import React from 'react';
import { getIsAdopted, getIsOnSale, getIsPending, getSaleCount } from '../../../../utils/adoptables';
import AdoptableSold from '../exclusives/presets/AdoptableSold';
import AdoptableForSale from '../exclusives/presets/AdoptableForSale';
import s from './AdoptableInfo.scss';
const AdoptableInfo = ({ deviation })=>{
    const saleCount = getSaleCount(deviation);
    const isAdopted = getIsAdopted(deviation);
    const isOnSale = getIsOnSale(deviation);
    const isPending = getIsPending(deviation);
    if (isAdopted || !isOnSale && !isPending && saleCount > 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement(AdoptableSold, {
            deviation: deviation
        }));
    }
    if (isOnSale || isPending) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement(AdoptableForSale, {
            deviation: deviation
        }));
    }
    return null;
};
AdoptableInfo.displayName = 'AdoptableInfo';
export default AdoptableInfo;
